export default __webpack_public_path__ + "static/media/monday.f0a776cc.png";